export const ADD_USER_DETAILS = "ADD_USER_DETAILS";
export const TOGGLE_THEME = "TOGGLE_THEME";
export const ADD_PROFILE_INFO = "ADD_PROFILE_INFO";
export const ADD_WINDOW_SIZE = "ADD_WINDOW_SIZE";
export const ADD_BOOKINGS_COUNT = "ADD_BOOKINGS_COUNT";
